import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTheme, ITheme } from 'src/theme';
import IconPencil from '@assets/icon/pencil.svg'
import { styled } from '@linaria/react';
import { PaymentRequest } from '@models/MLTC/PaymentRequest.model';
import { PaymentPremiumAmount, PaymentForm as PaymentModel } from '@models/MLTC/Payment.model';
import useForm from '@utils/useForm';
import { find, get, includes, isEmpty, set } from 'lodash';
import { css } from '@linaria/core';
import { Helpers } from '@utils/helpers';
import { setLoadingState } from '@redux/slices/loadingSlice';
import { updateBankId, updateCardHolderName, updateOtherBank, updatePolicyNo, updateReferenceNo, updatePremiumPaymentMethod } from '@redux/slices/MLTC/step5Slice';
import { getPolicyNo, postComputePremium, postPayment, postProductCheckMltc, savePayment, sendMail, sendMailMltc } from '@api/index';

import { LeftGrid, RightGrid, FullGrid, EmptyGrid, ContainerGrid, Container } from '@components/LayoutGrid';
import MultiSteps from '@components/MultiSteps';
import StickyBox from '@components/StickyBox';
import PremiumCost from '@components/PremiumCostMLTC';
import Heading from '@components/Heading';
import Divider from '@components/Divider';
import InformationBox from '@components/InformationBox';
import Text from '@components/Text';
import Button from '@components/Button';
import Modal from '@components/Modal';
import Link from '@components/Link';


import { validate } from './service';
import { useHistory } from 'react-router-dom';
import { useAvivaDispatch, useAvivaSelector } from '@redux/hook';
import { Coverages, SQSPocketResponse } from '@models/MLTC/SQSPocketRequest.model';

import TextCollapsible from '@components/TextCollapsible';
import ContainerBlock from '@components/ContainerBlock';
import Listing from '@components/Listing';
import Tag from '@components/Tag';
import InitialPremiumForm from './components/InitialPremiumForm';
import PaymentForm from './components/PaymentForm';
import AssignFinancialForm from './components/AssignFinancialForm';
import UnsuccessfulPayment from './components/UnsuccessfulPayment';
import CheckboxList from '@components/CheckboxList';
import Grid from '@components/Grid';
import Checkbox from '@components/Checkbox';
import Input from '@components/Input';
import Cell from '@components/Cell';
import Bullet from '@components/Bullet';
import { GAAviva } from '@utils/gaAviva';
import { UOB_CONTACT_URL } from '@static/config';

const fluidBox = css`
  margin-top: -40px;
`;

const alignRight = css`
  text-align: right;
`

const btnMinWidth = css`
  min-width: 138px;
`

const Row = styled.div<StyledProps>`  
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: ${props => props.variant === 'dash' ? '15px' : '8px'} ${props => props.variant === 'default' ? '0' : props.variant === 'table' ? 0 : '20px'};
  box-sizing: border-box;
  justify-content: space-between;
  border-bottom: ${props => props.variant === 'dash' ? `1px solid ${props.theme?.colors.grey[700]}` : 'unser'};
  margin: ${props => typeof props.marginItems === 'number' ? `${props.marginItems || 0}px` : props.marginItems || 0};
  &:nth-child(odd) {
    background-color: ${props => props.variant === 'alternate-color' ? props.theme?.colors.grey[600] : 'unset'};
  }
  &:nth-child(even) {
    background-color: ${props => props.variant === 'alternate-color' ? props.theme?.colors.white + '' : 'unset'};
  }
  &:last-child {
    border-bottom: ${props => props.variant === 'dash' ? `none` : 'unser'};
  }
`
const Col = styled.div<StyledProps>`
  width: ${props => props.variant === 'dash' ? '50%' : 'auto'};
  margin: ${props => props.margin || 0};
  flex-grow: 1;
`

const Flexbox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;


const page = 'Paymennt';

interface StyledProps {
  theme?: ITheme;
  variant: 'default' | 'alternate-color' | 'dash' | 'table';
  margin?: string | number;
  marginItems?: string | number;
}

const trackOnload = ({ payment = '', errorMessage = '', policyID = '', sumassured = '' }): void => {
  const GA = GAAviva.getInstance();
  let { page, acquisition, form } = GA.digitalData;
  page.errorMessage = errorMessage;
  acquisition.product.policyID = policyID;
  form.name = 'Payment';
  console.log({form})
  if (!isEmpty(payment)) {
    acquisition.insurance.paymentMethod = payment;
    acquisition.insurance.paymentOptions = 'Credit Card';
    acquisition.insurance.sumassured = sumassured;
  }
  GA.trackPageLoad({ page, acquisition, form });
}

const trackFormSubmmit = (error: string = ''): void =>  {
  const GA = GAAviva.getInstance();
  if (isEmpty(error)) {
    GA.trackFormSuccess({});
    return;
  }
  const { form } = GA.digitalData;
  form.error.messages = error;
  GA.trackFormFailed({ form });
}


/**
 * Local Modals
 */
const quoteInitialSample = [
  {
    name: '',
    type: 'basic',
    details: [
      { text: 'Plan', value: '-' },
      { text: 'Monthly benefit payout', value: '-' },
      { text: 'Plan&nbsp;structure', value: '-' },
      { text: 'Policy term', value: '-' },
      { text: 'Premium&nbsp;term', value: '-' },
      { text: 'Premium amount', value: '-' },
      { text: 'Promo code', value: '-' },
    ]
  },
];
const planOptions = {
  options: [
    { value: 'MLTC', description: `Singlife CareShield Standard`, key: 'myCareEnhanced' },
    { value: 'MLTCP', description: `Singlife CareShield Plus`, key: 'myCarePlusEnhanced' },
  ]
}

const planStructureOptions = {
  options: [
    { value: 'LEVEL', description: `I prefer fixed structure - same payout, same premium every year`, key: 'level' },
    { value: 'ESCALATING_2_PERCENT', description: `I prefer increasing payout and premium at 2% per year`, key: '2' },
    { value: 'ESCALATING_3_PERCENT', description: `I prefer increasing payout and premium at 3% per year`, key: '3' },
  ]
};

const premiumTermOptions = {
  options: [
    { value: 'OPTION_LIMITED', description: `For 0 years, until I'm 69 Age Next Birthday`, age: 0, key: 'limited' },
    { value: 'OPTION_LIFETIME', description: `For 0 years, until I'm 99 Age Next Birthday`, age: 0, key: 'lifetime' },
  ]
};

function Payment() {
  console.log(`QnB ➤ PAGE ➤ Aviva - ${page}`);
  const theme: ITheme = useTheme();
  // const premium: number = 300; // Will be imtegrated with redux;
  const history = useHistory();
  const dispatch = useAvivaDispatch();

  const campaignDetail = useAvivaSelector(state => state.loading.campaignDetail);
  const sourceOfFunds = useAvivaSelector(state => state.staticData.sourceOfFunds);
  const basicDetails = useAvivaSelector(state => state.mltcStep1.basicDetails);
  const quoteRawResponse = useAvivaSelector(state => state.mltcStep1.quoteRawResponse);
  const quoteRawRequest = useAvivaSelector(state => state.mltcStep1.quoteRawRequest);
  const promoCodeSummary = useAvivaSelector(state => state.mltcStep1.appliedPromoCode);

  const sqsQuotation = useAvivaSelector(state => state.mltcStep1.sqsQuotation);
  const initValue = useAvivaSelector(state => state.mltcStep1.coverage);
  const hasMyInfo = useAvivaSelector(state => state.mltcStep2.hasMyInfo);
  const retrieveMyInfo = useAvivaSelector(state => state.mltcStep2.retrievedMyInfo);
  const personalDetails = useAvivaSelector(state => state.mltcStep2.personalDetails);
  const incomeInfo = useAvivaSelector(state => state.mltcStep3.income);
  const bankId = useAvivaSelector(state => state.mltcStep5.bankId);
  const otherBank = useAvivaSelector(state => state.mltcStep5.otherBank);
  const referenceNo = useAvivaSelector(state => state.mltcStep5.referenceNo);
  const rawAgentDetailResponse = useAvivaSelector(state => state.mltcStep5.agentDetailResponseRaw);

  const [monthlyBenefit, setMonthlyBenefit] = useState<any>('');
  const [premium, setPremium] = useState<any>({});
  const [quotes, setQuotes] = useState<any>(quoteInitialSample);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [isStatusCheck, setIsStatusCheck] = useState<boolean>(false);
  const [isPolicyExisit, setIsPolicyExisit] = useState<boolean>(false);

  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [isShowPromoCode, setIsShowPromocode] = useState<boolean>(false);
  const [isModifyingAmount, setIsModifyingAmount] = useState<boolean>(true);
  const [isCpfOnly, setIsCpfOnly] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);

  const [premiumPayment, setPremiumPayment] = useState<PaymentPremiumAmount>();
  const { values, errors, handleChange, formValid, patchValue } = useForm(new PaymentModel(null), () => { }, validate)
  const [selectedFinancial, setSelectedFinancial] = useState<string>('ARISTOTLE');
  const [agentCode, setAgentCode] = useState<string>('');
  const [agentSourceBusiness, setAgentSourceBusiness] = useState<string>('');
  const [campaignCode, setCampaignCode] = useState<string>('MLO1');

  const [isPaymentClick, setIsPaymentClick] = useState<boolean>(false);

  const [isShowUOB, setIsShowUOB] = useState<boolean>(false);
  const gotoUOBContact = () => {
    window.open(UOB_CONTACT_URL, "_blank", "noopener noreferrer");
  };
  const paramCC = campaignDetail?.campaignCode ? `?cc=${campaignDetail.campaignCode}` : '';
  // const combineParamCC = campaignDetail?.campaignCode ? `&cc=${campaignDetail.campaignCode}` : '';

  const gotoContact = () => {
    if (campaignCode === 'LUB1') {
      setIsShowUOB(true);
    }
    else {
      history.push('/mltc-r2/contact' + paramCC);
    }
  }

  const toggleModalPromoCode = () => { setIsShowPromocode(!isShowPromoCode) };
  
  const validatePromoCode = useCallback(async (promoCode: any) => {
    console.log('validatePromoCode', promoCode);
    if (isEmpty(promoCode)) {
      return true;
    }
    const payload = { ...quoteRawRequest };
    // set(payload, 'coverages[0].attributes.promoCodeSummary', promoCodeSummary);
    const response = await postComputePremium(payload, true);
    const data = get(response, 'data.data', {});
    const pocket = new SQSPocketResponse(data);
    const checkedCode = pocket.checkValidPromoCode(promoCode);
    const { valid } = checkedCode;
    return valid;
  }, [quoteRawRequest, promoCodeSummary]);

  const setLoading = useCallback((value: boolean) => {
    dispatch(setLoadingState(value));
  }, [dispatch])

  const onEdit = useCallback(() => {
    setIsModifyingAmount(prev => !prev);
  }, []);
  const toggleModal = useCallback(() => { setIsShowModal(prev => !prev) }, []);

  const onEditQuote = useCallback(() => {
    console.log(`QnB ➤ onEditQuote ➤ `);
    history.push('/mltc-r2/choose-plan' + paramCC);
  }, []);

  const onBack = useCallback((path: string = '/mltc/review') => {
    console.log('hasError', { hasError })
    if (hasError) {
      setHasError(false);
    } else {
      history.push('/mltc-r2/review' + paramCC);
    }
  }, [hasError, history]);

  const onTryAgain = useCallback(() => {
    setHasError(false);
  }, []);


  const onChangedAmount = useCallback((value: PaymentPremiumAmount) => {
    console.log(`QnB ➤ onChangedAmount(value)`, { value });
    setPremiumPayment(value);
    setIsCpfOnly((value.creditCardAmount == 0));
    setIsModifyingAmount(prev => !prev);
    dispatch(updatePremiumPaymentMethod(value));
    patchValue({ isAuthorised: true })
  }, [dispatch, setIsCpfOnly, setPremiumPayment]);

  const onCancelChangedAmount = useCallback((value: PaymentPremiumAmount) => {
    console.log(`QnB ➤ onCancelChangedAmount(value)`);
    patchValue({ isAuthorised: true })
  }, [dispatch, setIsCpfOnly, setPremiumPayment]);

  const onChangedAssignFinancial = useCallback((selected) => {
    console.log(`QnB ➤ onChangedAssignFinancial(selected)`, { selected });
    setSelectedFinancial(selected);
  }, []);

  const onVerifyCallback = useCallback((agentCode, sourceOfBusiness) => {
    console.log(`QnB ➤ onVerifyCallback(agentCode)`, { agentCode, sourceOfBusiness });
    setAgentCode(agentCode);
    setAgentSourceBusiness(sourceOfBusiness);
  }, []);


  const isValid: boolean = useMemo(() => {
    if (isEmpty(premiumPayment)) {
      return false;
    }
    if (campaignCode === 'MLO1' && isEmpty(selectedFinancial)) {
      return false;
    }
    console.log({ selectedFinancial, code: isEmpty(agentCode) });
    if (selectedFinancial === 'USER_PREFERRED' && isEmpty(agentCode)) {
      return false;
    }
    if (!isCpfOnly && !values['fund']) {
      return false;
    }
    if (!isCpfOnly) {
      return formValid;
    }
    console.log('valid true');
    return true

  }, [isCpfOnly, campaignCode, selectedFinancial, formValid, agentCode, values]);



  const handleCallback = useCallback(() => { }, []);

  const onSuccessPayment = useCallback(async (payload: any) => {
    dispatch(setLoadingState(true));
    try {
      const quotation: SQSPocketResponse = new SQSPocketResponse(quoteRawResponse);
      const coverage: Coverages | undefined = find(quotation.coverages, { type: 'P' });
      const response = await getPolicyNo(payload, 3, retrieveMyInfo?.id);
      const policyNo = get(response, 'data');
      dispatch(updatePolicyNo(String(policyNo)));
      dispatch(setLoadingState(false));
      trackOnload({ policyID: policyNo, payment: Helpers.getBankName(`${bankId}`) || otherBank, sumassured: `${quotation.sumAssured || 0}` });
      // trackFormSubmmit();
      sendMailMltc(payload, 3, retrieveMyInfo?.id); // , quotation.totalAftDisOriginalPremiumAmt, quotation.monthlyBenefit);
      // await onSavePayment(policyNo);
      history.push('/mltc-r2/thank-you' + paramCC);
    } catch (err) {
      // trackFormSubmmit(get(err, 'message'));
      dispatch(setLoadingState(false));
      history.push('/mltc-r2/thank-you' + paramCC);
    }
  }, [dispatch, history, bankId, otherBank, quoteRawResponse, retrieveMyInfo]);

  const onFailedPayment = useCallback(async (payload: any) => {
    // dispatch(setLoadingState(true));
    trackFormSubmmit('Payment is unsuccessful');
    dispatch(setLoadingState(false));
  }, [dispatch])

  const checkStatus = useCallback(() => {
    const params = new URLSearchParams(window.location.href.split('?')[1]);
    const status = params.get('status');
    console.log('data saved referenceNo', referenceNo, status);
    if (!isStatusCheck) {
      if (referenceNo !== '' && status === 'processing') {
        setIsProcessing(true);
        trackFormSubmmit();
        dispatch(setLoadingState(true));
        console.log('is payment success');
        onSuccessPayment(referenceNo);
      } else if (status === 'unsuccessful') {
        setHasError(true);
        trackOnload({ policyID: referenceNo, payment: Helpers.getBankName(`${bankId}`) || otherBank, errorMessage: 'Payment is unsuccessful' });
        onFailedPayment(referenceNo);
        setLoading(false);
      } else {
        trackOnload({});
        setLoading(false);
      }
      setIsStatusCheck(true);
      setLoading(false);
    }
  }, [referenceNo, onSuccessPayment, setHasError, setIsProcessing, setLoading, otherBank, onFailedPayment, isStatusCheck, dispatch, bankId]);



  const onSavePayment = useCallback(async (contractCode: string, paymentPayload: any, policyNo?: string) => {
    const quotation: SQSPocketResponse = new SQSPocketResponse(quoteRawResponse);
    const coverage: Coverages | undefined = find(quotation.coverages, { type: 'P' });
    // const totalPayablePremium = Number(quotation.dpiPremium.totalPremium.value.toString().replace('S$', '')) || 1;
    const totalPayablePremium = premiumPayment?.creditCardAmount;
    let sourceOfFunds = '';
    if (!isCpfOnly) {
      values['fund'].forEach((item: string) => {
        const f_item = item === 'other' ? `OTH` : item;
        sourceOfFunds = sourceOfFunds ? `${sourceOfFunds}|${f_item},${item === 'other' ? values['otherFund'] : 'Y'}` : `${f_item},${item === 'other' ? values['otherFund'] : 'Y'}`;
      });
    }
    console.log('CHECK', coverage, values['bank'], Number(values['bank']));
    const cpfAmt = premiumPayment?.cpfMediSaveAmount || 0;
    const ccAmt = premiumPayment?.creditCardAmount || 0;
    const payload = {
      policy: {
        // "policyNumber": policyNo,
        "contractCode": contractCode,
        "customerId": retrieveMyInfo?.id,
        "productId": 3,
        "planName": coverage?.name,
        "sumAssured": quotation.monthlyBenefit,
        "premiumTerm": sqsQuotation?.premiumTerm,
        "premiumAmount": coverage?.attributes?.modalPremium,
        "premiumPaymentFrequency": quotation.coverages[0].attributes?.planPremiumMode,
        "totalAnnualPremium": quotation.totalOriginalPremiumAmt || 0,
        "afterPromoDiscount": quotation.totalAftDisOriginalPremiumAmt || 0,
        "firstYearDiscount": sqsQuotation?.totalFirstYearDiscount,
        "perpetualDiscount": sqsQuotation?.totalPerpetualDiscount,
        "discountType": coverage?.attributes?.discountedPremium.firstYrDiscType === 'percent' ? 'percentage' : coverage?.attributes?.discountedPremium.firstYrDiscType === 'dollar' ? 'dollar' : '',
        "promoCode": quotation.promoCode,
        "campaignCode": campaignDetail?.campaignCode,
        "productCode": initValue?.plan,//quotation?.coverages[0].productCode,
        "quotationRespData": quoteRawResponse ? JSON.stringify(quoteRawResponse) : '{}', //json str
        "sourceBusiness": '',
        "contractCurrency": 'SGD',
        "smokingStatus": basicDetails?.smoker,
        "policyIllustrationPDFPath": '',
        "agentSourceCode": agentCode,
        "agentDetailsRespData": selectedFinancial === 'USER_PREFERRED' ? JSON.stringify(rawAgentDetailResponse) : '{}',
        "agentOptionChosen": selectedFinancial,
        "planStructure": sqsQuotation?.planStructure,
        "formType": (!!campaignDetail) ? campaignDetail?.code : 'MLO1',
        "cpfMedisaveAmount": premiumPayment?.cpfMediSaveAmount,
        "premiumTermOption": sqsQuotation?.premiumTermOption,
        "premiumTermDesc": sqsQuotation?.premiumTermDesc,
        "partnerCode": campaignDetail?.partner,
        "annualIncome": incomeInfo?.income,
        "exactDutiesOccupation": incomeInfo?.duties,
        "agentSourceOfBusiness": agentSourceBusiness,
        "paymentMode": (cpfAmt > 0) ? (ccAmt > 0) ? 'CPF_CC' : 'CPF' : 'CC',
        "sourceOfFunds": sourceOfFunds
      },
      payment: {
        cardHolderNric: get(personalDetails, 'nric', null),
        cardHolderName: get(personalDetails, 'fullName', null),
        bankId: Number(values['bank']),
        paymentAmount: totalPayablePremium,
        // referenceNo: referenceNo, //reference no
        otherBank: values['others']
      }
    }
    try {
      dispatch(setLoadingState(true));
      const response = await savePayment(payload);
      const refNo = get(response, 'data', '');
      console.log('refno', refNo);
      console.log('savePayment', refNo);
      paymentPayload.referenceNumber = refNo;
      dispatch(updateReferenceNo(String(refNo)));

      postPayment(paymentPayload).then((res: any) => {
        console.debug('postPayment', res);
        const paymentUrl = get(res, 'data');

        console.log(paymentUrl.split('?')[1]);
        // const params = new URLSearchParams(paymentUrl.split('?')[1]);
        // const refNo = params.get('referenceNumber');

        dispatch(updateCardHolderName(values['name']));
        dispatch(updateBankId(Number(values['bank'])));
        dispatch(updateOtherBank(values['others']));

        const fullPath = window.location.origin + window.location.pathname.replace('/index.html', '') + '#/mltc/payment?status=processing';
        console.log(fullPath);
        if (!isCpfOnly) {
          setLoading(true);
          window.open(paymentUrl, '_self');
        } else {
          setLoading(false);
          onSuccessPayment(refNo);
          //history.push('/mltc-r2/thank-you')
          // setTimeout(() => {
          //   window.open(fullPath, '_self');
          // }, 1000)
        }
      }).catch((err: any) => {
        setLoading(false);
        console.error(err);
        setHasError(true);
      });

    } catch (error) {
      dispatch(setLoadingState(false));
    }
  }, [dispatch, isCpfOnly, values, agentSourceBusiness, agentCode, basicDetails, sqsQuotation, quoteRawResponse, personalDetails, retrieveMyInfo, selectedFinancial, setLoading]);

  const onClickConfirmAndPay = async () => {
    if (isPaymentClick) return;
    setIsPaymentClick(true);
    setTimeout(() => {
      setIsPaymentClick(false);
    }, 5000);
    
    const promoCode = get(quoteRawRequest, 'coverages[0].attributes.promoCodeSummary', '')
    console.log('onClickConfirmAndPay', { promoCodeSummary, quoteRawRequest, promoCode });
    // validatePromoCode(promoCode)
    if (!await validatePromoCode(promoCode)) {
      toggleModalPromoCode();
      return;
    }
    await processPayment();
  };

  const processPayment = useCallback(async () => {
    setLoading(true);
    dispatch(setLoadingState(true));
    const pocket = new SQSPocketResponse(quoteRawResponse);
    const coverage: Coverages | undefined = find(pocket.coverages, { type: 'P' });
    // const totalPayablePremium = Number(pocket.mltcPremium.totalPremium.value.toString().replace('S$', '')) || 1; // for testing
    const totalPayablePremium = Helpers.toTwoDecimal(premiumPayment?.creditCardAmount);

    const payload = new PaymentRequest({
      amount: totalPayablePremium,
      productName: 'MLTC',
      contractCode: coverage?.productCode || ''
    });

    dispatch(updateCardHolderName(values['name']));
    dispatch(updateBankId(Number(values['bank'])));
    dispatch(updateOtherBank(values['others']));
    onSavePayment(coverage?.productCode || '' || '', payload);
  }, [ setLoading, dispatch, values, quoteRawResponse, onSavePayment ]);

  const checkProduct = useCallback(async (nric: string) => {
    try {
      const response = await postProductCheckMltc(nric);
      const policyExistRes = get(response, 'data', '');
      console.debug(`QnB ➤ checkProduct() ➤ `, { request: nric, response, policyExistRes: policyExistRes.policyExist });
      // return true;
      setIsPolicyExisit(policyExistRes.policyExist);
      return policyExistRes.policyExist;
    } catch (error) {
      setIsPolicyExisit(false);
      console.error(error);
      return false;
    }
  }, []);

  useEffect(() => {
    // setIsLowCost(premium < 600);
    // dispatch(setLoadingState(false));
    const params = new URLSearchParams(window.location.href.split('?')[1]);
    const status = params.get('status');
    const nextQuotes = [...quoteInitialSample];
    setQuotes(nextQuotes);

    console.log(
      'QnB ➤ Payment ➤ useEffect() ➤',
      {
        'step1Slice ➤ basicDetails': basicDetails,
        'step1Slice ➤ initValue': initValue,
        'local ➤ values': values,
        campaignDetail,
        hasMyInfo,
        quoteRawResponse,
        retrieveMyInfo,
        sqsQuotation,
        personalDetails
      }
    );

    if (campaignDetail) {
      setSelectedFinancial('NO_AGENT');
      setCampaignCode(campaignDetail?.code);
    }

    if (!isEmpty(basicDetails)) {
      const { month, day, year } = basicDetails?.dob || { month: '', day: '', year: '' };
      if (isEmpty(basicDetails?.dob)) onBack();
      const stringDate = `${month}/${day}/${year}`;
      const age = Helpers.getAge(new Date(stringDate));
      // setAge(age);
      console.log('QnB ➤ useEffect() ➤ basicDetails is not empty ➤',
        { stringDate, age }
      );
      premiumTermOptions.options = [
        {
          value: 'OPTION_LIMITED',
          description: `For ${age >= 49 ? 20 : 69 - age} years, until I'm ${age >= 49 ? age + 20 : 69} Age Next Birthday`,
          age: age >= 49 ? 20 : 69 - age,
          key: 'limited'
        },
        {
          value: 'OPTION_LIFETIME',
          description: `For ${99 - age} years, until I'm 99 Age Next Birthday`,
          age: 99 - age,
          key: 'lifetime'
        },
      ]
    } else {
      onBack();
    }

    if (personalDetails) {
      patchValue({
        no: personalDetails.nric,
        name: personalDetails.fullName
      });
      checkProduct(personalDetails.nric || '');
    }


    const _premium = new SQSPocketResponse(quoteRawResponse);
    let planStructure, premiumTerm: any;
    let basicTarget = find(quotes, { type: 'basic' });
    let planName = (initValue?.plan === 'MLTC') ? planOptions.options[0].description : planOptions.options[1].description;
    switch (initValue?.escBenefit) {
      case 'level': planStructure = planStructureOptions.options[0]; break;
      case '2': planStructure = planStructureOptions.options[1]; break;
      case '3': planStructure = planStructureOptions.options[2]; break;
    }
    switch (initValue?.premiumTerm) {
      case 'limited': premiumTerm = premiumTermOptions.options[0]; break;
      case 'lifetime': premiumTerm = premiumTermOptions.options[1]; break;
    }
    set(basicTarget, 'details[0].value', planName);
    set(basicTarget, 'details[1].value', Helpers.toCurrency(Number(initValue?.monthlyBenefit)));
    set(basicTarget, 'details[2].value', planStructure?.description);
    set(basicTarget, 'details[3].value', 'Lifetime');
    set(basicTarget, 'details[4].value', premiumTerm?.description);
    set(basicTarget, 'details[5].value', Helpers.toCurrency(_premium.totalAftDisOriginalPremiumAmt || 0));
    set(basicTarget, 'details[6].value', _premium.promoCode);
    setQuotes([...quotes]);
    setPremium(_premium.mltcPremium);
    setMonthlyBenefit(Number(initValue?.monthlyBenefit));
    console.log('QnB ➤ useEffect() ➤ after set premium', { premium: _premium.mltcPremium })
    checkStatus();

    if (premium.totalAnnualizedPremium <= 600) {
      setIsCpfOnly(true);
    }

    if (isEmpty(basicDetails)) { onBack('/mltc/lets-get-started'); }

    if (status) {
      handleCallback();
    }

  }, [setCampaignCode, campaignCode]);

  const onFocusOnOthers = (type: 'fund' | 'wealth'): void => {
    const currentValue = values[type];
    let nextValue;
    if (!currentValue) {
      nextValue = ['other'];
      patchValue({ [type]: nextValue });
    } else {
      if (!includes(currentValue, 'other') && Array.isArray(currentValue)) {
        nextValue = [...currentValue, 'other'];
        patchValue({ [type]: nextValue });
      }
    }
    console.log(currentValue, values, type, nextValue);

  }

  const onChangeCheckBox = (item: any, type: string) => (event: any) => {
    const { value } = event.target;
    const currentValue = values[type];
    let nextValue = currentValue ? [...currentValue] : [];
    if (value) {
      nextValue.push(item.value);
    } else {
      nextValue = nextValue.filter((o: any) => o !== item.value);
    }
    const nextValueCheckbox = { [type]: nextValue }
    patchValue(nextValueCheckbox);
    
    
  }

  const renderCheckboxes = (sources: any[], type: string) => sources.map((source, index: number) => {
    return (<Checkbox key={`${index}`} variant="border" checked={includes(values[type], source.value)} onChange={onChangeCheckBox(source, type)}><Text>{source.label}</Text></Checkbox>)
  });

  return (
    <>
      {hasError && (
        <Container>
          <ContainerGrid>
            <UnsuccessfulPayment tryAgain={onTryAgain} />
          </ContainerGrid>
        </Container>

      )}
      {isProcessing && (
        <ContainerBlock className={fluidBox} background={theme.colors.secondary} padding="40px 0" paddingTablet="130px 0 110px 30px">
          <ContainerGrid>
            <FullGrid>
              <LeftGrid>
                <Heading fontWeight={600} color={theme.colors.white} margin="0 0 10px">Thank you! </Heading>
                <Text fontSize={theme.fontSize.label} fontWeight={300} color={theme.colors.white}>Your application has been submitted. We’ll notify you on the status of your application within 5 working days.</Text>
              </LeftGrid>
            </FullGrid>
          </ContainerGrid>
        </ContainerBlock>
      )}
      {(!hasError && !isProcessing) && (
        <>
          <Container>
            <ContainerGrid>
              <FullGrid>
                <MultiSteps margin="0 0 20px" steps={5} step={5} label="Payment" />
                <StickyBox>
                  <PremiumCost {...premium} />
                </StickyBox>
              </FullGrid>
              <LeftGrid>
                <Heading margin="0 0 30px"> Premium payment </Heading>
                <Flexbox>
                  <Heading variant="smallTitle" fontWeight={600} margin="0 5px 15px"> How would you like to pay? </Heading>
                  {!isModifyingAmount && (
                    <Link margin="10px 0 10px" className={btnMinWidth} onClick={() => { onEdit() }} variant="button" text="Modify&nbsp;amount" icon={IconPencil} slotIcon="start"></Link>
                  )}
                </Flexbox>
                <Divider size={1} margin="0 0 30px" />
                <InitialPremiumForm isEditing={isModifyingAmount} premium={premium.totalAnnualizedPremium} onSave={onChangedAmount} onCancel={onCancelChangedAmount} nric={values['no']} />
                {!isPolicyExisit && (<InformationBox hasClose margin="0 0 30px">
                  <Text>Do note that we&apos;ll deduct up to S$600 per calendar year from your CPF MediSave account for your premium.&nbsp;
                    {isCpfOnly && (<>In the event that your CPF MediSave account has insufficient funds, you&apos;ll be notified by post, or via your financial representative.</>)}
                    {!isCpfOnly && (<>In the event that your CPF MediSave account has insufficient funds, the remaining balance will be charged to your credit card which you have provided below.</>)}
                  </Text>
                </InformationBox>)}
                {isPolicyExisit && (<InformationBox hasClose margin="0 0 30px">
                  <Text fontWeight={600}>You have an existing LongTermCare plan with us. </Text>
                  <Text>Do note that we&apos;ll deduct up to S$600 per calendar year from your CPF MediSave account for your premium.&nbsp;
                    {isCpfOnly && (<>In the event that your CPF MediSave account has insufficient funds, you&apos;ll be notified by post, or via your financial representative.</>)}
                    {!isCpfOnly && (<>In the event that your CPF MediSave account has insufficient funds, the remaining balance will be charged to your credit card which you have provided below.</>)}
                  </Text>
                </InformationBox>)}
                {!isEmpty(premiumPayment) && !isCpfOnly && (<PaymentForm premium={Number(premiumPayment?.creditCardAmount)} values={values} handleChange={handleChange} errors={errors} />)}

                {(!isCpfOnly && values['isAuthorised']) && (
                  <ContainerBlock paddingTablet="0 30px 0" marginTablet={'0 0 30px 0'} padding="0 20px" background={theme.colors.grey[200]}>
                    <Heading variant="smallTitle" fontWeight={600} margin="0 0 15px"> Source of funds </Heading>
                    <Divider size={1} margin="0 0 30px" />
                    <Heading variant="label"> Please select your source of funds </Heading>
                    <CheckboxList>
                      {renderCheckboxes(sourceOfFunds, 'fund')}
                      {!errors?.otherFund?.isValid && errors?.otherFund?.message && <Bullet variant="error">{errors?.otherFund?.message}</Bullet>}
                      <Grid columns={5}>
                        <Cell width={2}><Checkbox variant="border" checked={includes(values['fund'], 'other')} onChange={onChangeCheckBox({ value: 'other' }, 'fund')}><Text>Others</Text></Checkbox></Cell>
                        <Cell width={3}><Input maxLength={50} name="otherFund" invalid={!isEmpty(errors?.otherFund?.message)} onFocus={() => onFocusOnOthers('fund')} placeholder="Please specify" onChange={handleChange} value={values['otherFund']} /></Cell>
                      </Grid>
                    </CheckboxList>
                  </ContainerBlock>
                )}
                {(!isCpfOnly && values['isAuthorised']) && (
                  <InformationBox hasClose margin="0 0 30px">
                    <Text fontWeight={600}>Please ensure you&apos;ve provided your own credit card details. </Text>
                    <Text>
                      If you’re unable to make payment using your own credit card, please leave your contact details <Link text="here" variant="button" onClick={gotoContact} />
                      {campaignCode === 'LUB1' ?
                        ' and a UOB Bancassurance Specialist will contact you shortly.' :
                        ' and our financial adviser representative will be in touch with you shortly.'}
                    </Text>
                  </InformationBox>
                )}
                {/* {campaignDetail?.code} {campaignCode} */}
                {(
                  (campaignCode === 'MLO1' || isEmpty(campaignDetail?.code)) &&
                  !isEmpty(premiumPayment) &&
                  (
                    isCpfOnly ||
                    (!isEmpty(values['fund']) || !isEmpty(values['otherFund']))
                  )
                ) &&
                  (<AssignFinancialForm onChange={onChangedAssignFinancial} onVerify={onVerifyCallback} />
                  )}
                {(campaignCode === 'MLO1' || !isCpfOnly) && (
                  <Button margin="50px 0 20px" label='Confirm and pay' onClick={onClickConfirmAndPay} disabled={!isValid} />
                )}
                {(campaignCode !== 'MLO1' && isCpfOnly) && (
                  <Button margin="50px 0 20px" label='Confirm and pay' onClick={onClickConfirmAndPay} disabled={isModifyingAmount} />
                )}
                <Button label='Back' variant='secondary' onClick={onBack} />
              </LeftGrid>
              <EmptyGrid>
              </EmptyGrid>
              <RightGrid>
                <ContainerBlock
                  borderTop={`3px solid ${theme.colors.primary}`}
                  boxShadow="0 2px 2px 0 rgba(204, 204, 204, 0.5)"
                  background={theme.colors.grey[200]}
                  padding={20}
                  paddingTablet="20px 30px 10px">
                  <Heading margin="0 0 20px" color={theme.colors.grey[400]} variant="smallTitle" fontWeight={600}>Your quote details</Heading>
                  <Text>The maximum CPF MediSave deduction limit is S$600 per person per calendar year. The balance premium(s) or any insufficient amount in the CPF MediSave account will be charged to your credit card.</Text>
                  <Divider size={1} margin="20px 0 20px" />
                  <Listing marginItems="0 0 4px" sources={[quotes[0].details[0]]} margin="0 0 12px" />

                  <Listing marginItems="0 0 4px" sources={[{ text: 'Monthly benefit payout', value: monthlyBenefit ? Helpers.toCurrency(Number(monthlyBenefit)) : '-' }]} margin="0 0 12px" />
                  {(monthlyBenefit != false) && <TextCollapsible labelMore="Additional care benefits" labelLess="Additional care benefits" margin="10px 0 15px" expanded={false}>
                    <ContainerBlock
                      background={theme.colors.white}
                      padding={20}
                      paddingTablet="20px 20px 10px">
                      <Text margin="0 0 10px" fontWeight={600}>Additional care benefits*</Text>
                      <Listing marginItems="0 0 4px" variant='table' sources={[{ text: 'Lump-sum benefit', value: Helpers.toCurrency(Number(monthlyBenefit * 3)) }]} margin="0 0 12px" />
                      <Text margin="-12px 0 10px" fontWeight={400} fontSize={14}>3X of first monthly benefit payout</Text>

                      <Listing marginItems="0 0 4px" variant='table' sources={[{ text: 'Rehabilitation benefit', value: Helpers.toCurrency(Number(monthlyBenefit * 50 / 100)) }]} margin="0 0 12px" />
                      <Text margin="-12px 0 0" fontWeight={400} fontSize={14}>50% of monthly benefit payout</Text>
                      <Text margin="0 0 10px" fontWeight={400} fontSize={14}>(for Singlife CareShield Standard only)</Text>

                      <Listing marginItems="0 0 4px" variant='table' sources={[{ text: 'Caregiver relief benefit', value: Helpers.toCurrency(Number(monthlyBenefit * 60 / 100)) }]} margin="0 0 12px" />
                      <Text margin="-12px 0 10px" fontWeight={400} fontSize={14}>60% of monthly benefit payout</Text>

                      <Listing marginItems="0 0 4px" variant='table' sources={[{ text: 'Dependant care benefit', value: Helpers.toCurrency(Number(monthlyBenefit * 20 / 100)) }]} margin="0 0 12px" />
                      <Text margin="-12px 0 10px" fontWeight={400} fontSize={14}>20% of monthly benefit payout</Text>

                      <Listing marginItems="0 0 4px" variant='table' sources={[{ text: 'Death benefit', value: Helpers.toCurrency(Number(monthlyBenefit * 3)) }]} margin="0 0 12px" />
                      <Text margin="-12px 0 10px" fontWeight={400} fontSize={14}>3X monthly benefit payout</Text>

                      <Text margin="20px 0 10px" fontWeight={600}>Waiver of Premium</Text>
                      <Text margin="20px 0 10px" fontWeight={600}>Guaranteed Issuance Option</Text>

                    </ContainerBlock>
                  </TextCollapsible>}
                  <Listing marginItems="0 0 4px" sources={[quotes[0].details[2]]} margin="0 0 12px" />
                  <Listing marginItems="0 0 4px" sources={[quotes[0].details[3]]} margin="0 0 12px" />
                  <Listing marginItems="0 0 4px" sources={[quotes[0].details[4]]} margin="0 0 12px" />
                  <Listing marginItems="0 0 4px" sources={[quotes[0].details[5]]} margin="0 0 12px" />
                  <Listing marginItems="0 0 4px" sources={[quotes[0].details[6]]} margin="0 0 12px" />
                  <Container>
                    {(premium.firstYearDiscountEligible) &&
                      (<Row variant={'table'}>
                        <Col variant={'default'}>
                          <Tag variant="promo">1st Year Discount</Tag>
                        </Col>
                        <Col variant={'default'} className={alignRight}><strong>{premium.totalFirstYearDiscount}</strong></Col>
                      </Row>)}
                    {(premium.perpetualDiscountEligible) &&
                      (<Row variant={'table'}>
                        <Col variant={'default'}>
                          <Tag variant="promo">Perpetual Discount</Tag>
                        </Col>
                        <Col variant={'default'} className={alignRight}><strong>{premium.totalPerpetualDiscount}</strong></Col>
                      </Row>)}
                  </Container>
                  <Divider size={1} variant='dashed' margin="20px 0 20px" />
                  <Text margin="0 0 10px" fontWeight={400} fontSize={14}>* Please refer to the Product Summary for more details.</Text>
                  <Link margin="0 0 10px" onClick={() => { toggleModal() }} variant="button" text="Modify quote" icon={IconPencil} slotIcon="start"></Link>
                </ContainerBlock>

                {/* <Quote
                  onEdit={toggleModal}
                  details={quoteInitialSample}
                  description='Your maximum CPF Medisave deduction limit is $600 per person per calener year. The balance premium(s) or any insufficient amount in the CPF MediSave account will be paid via your selected payment method.'
                /> */}
              </RightGrid>

              <Modal show={isShowUOB} onClose={() => { setIsShowUOB(false) }}>
                <Text margin={'0px 0 30px'}>You will be redirected to our appointed intermediary - United Overseas Bank Limited (“UOB”) site to submit the contact me form.</Text>
                <Button margin="0 0 20px" label="Proceed" onClick={gotoUOBContact} />
                <Button variant="secondary" label="Cancel" margin={0} onClick={() => { setIsShowUOB(false) }} />
              </Modal>
            </ContainerGrid>
          </Container>
          <Modal show={isShowModal} onClose={toggleModal}>
            <Heading fontWeight={600} variant="smallTitle" margin="0 0 20px" marginTablet="0 0 30px">Modify quote</Heading>
            <Text margin="0 0 27px">You will need to answer the underwriting questions once again if there is a change from the initial quotation.</Text>
            <Button margin="0 0 20px" label="Proceed" onClick={onEditQuote}></Button>
            <Button margin={0} label="Cancel" variant="secondary" onClick={toggleModal}></Button>
          </Modal>
          <Modal show={isShowPromoCode} onClose={toggleModalPromoCode}>
            <Heading fontWeight={600} variant="smallTitle" margin="0 0 20px" marginTablet="0 0 30px">Invalid promo code</Heading>
            <Text margin="0 0 30px" >You are not eligible for the promo code. Please return to the quotation page to remove the promo code. </Text>
            <Text margin="0 0 30px" >Alternatively, you may leave your contact details <Link text="here" variant="button" onClick={gotoContact} /> and our financial adviser representative will be in touch with you shortly.</Text>
            <Button margin="0 0 20px" label="Proceed to edit promo code" onClick={onEditQuote}></Button>
          </Modal>
        </>

      )}
    </>
  );
};

export default Payment;
